"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CalendarIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
}, props));
CalendarIcon.displayName = 'CalendarIcon';
var _default = exports.default = CalendarIcon;